import { createResponsiveStyles } from "../../utils";
import { theme } from "../../theme";
import ResponsiveStyleSheet from "react-native-media-query";
export const { styles, ids } = ResponsiveStyleSheet.create({
    wrapper: {
        padding: 0,
        zIndex: 1,
        elevation: 1,
    },
    portraitWrap: {
        display: "flex",
        alignItems: "center",
        paddingTop: theme.spacing.xlarge2,
        paddingBottom: theme.spacing.small,
        paddingHorizontal: theme.spacing.small,
        height: "100%",
    },
    landscapeWrap: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        paddingHorizontal: theme.spacing.small,
        alignContent: "center",
        alignItems: "center",
    },
    pillWrapper: {
        position: "absolute",
        top: -theme.spacing.small,
        alignItems: "center",
        left: 0,
        right: 0,
        zIndex: 2,
        elevation: 2,
    },
    heading: createResponsiveStyles({
        base: {
            textAlign: "center",
            marginTop: theme.spacing.small,
            paddingHorizontal: theme.spacing.xlarge,
        },
        medium: {
            height: "100%",
            marginBottom: theme.spacing.xlarge3,
            margin: 0,
        },
    }),
    button: {
        marginTop: theme.spacing.small,
    },
    children: {
        marginTop: theme.spacing.small,
        width: "100%",
        paddingHorizontal: theme.spacing.small,
        paddingBottom: theme.spacing.small,
    },
});
//# sourceMappingURL=CTA.styles.js.map